import React, { useState } from 'react';
import PropTypes from 'prop-types';

const PromoteSiteNewsletterItem = ({
  newsletter,
  handleNewsletterSelect,
  handleNewsletterDeselect,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const itemId = newsletter.top_header.split(' ').join('_').toLowerCase();

  const toggleExpanded = (e) => {
    e.stopPropagation();
    setIsExpanded((prev) => !prev);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleExpanded();
    }
  };

  return (
    <div className={`site-item ${isExpanded ? 'expanded' : ''}`}>
      <div className="site-item__row">
        <div className="site-item__checkbox-col">
          <div className="site-item__checkbox-label">
            <input
              aria-label={`Select ${newsletter.top_header}`}
              className="site-item__checkbox-input"
              type="checkbox"
              onChange={(event) => {
                event.stopPropagation();
                return event.target.checked
                  ? handleNewsletterSelect(newsletter.top_header)
                  : handleNewsletterDeselect(newsletter.top_header);
              }}
              checked={newsletter.selected}
              id={itemId}
            />
            <span className="site-item__checkbox" aria-hidden="true" />
          </div>
        </div>
        <button
          className="site-item__content-col"
          onClick={toggleExpanded}
          onKeyDown={handleKeyDown}
          type="button"
          tabIndex={0}
          style={{ width: '100%', textAlign: 'left' }}
          aria-expanded={isExpanded}
        >
          <div className="site-item__header-row">
            <span className="site-item__name">{newsletter.top_header}</span>
            <span className="site-item__delivery">{newsletter.delivery_days.toUpperCase()}</span>
            <svg
              className={`chevron-icon ${isExpanded ? 'rotated' : ''}`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 13.28 7.59"
              aria-hidden="true"
            >
              <path d="M8,5.25H8l5.16-5a0.34,0.34,0,0,1,.47,0l0.91,0.89a0.32,0.32,0,0,1,0,.45h0L8.24,7.7A0.31,0.31,0,0,1,8,7.79,0.33,0.33,0,0,1,7.75,7.7L1.45,1.65a0.32,0.32,0,0,1,0-.45h0L2.36,0.3a0.34,0.34,0,0,1,.47,0Z" transform="translate(-1.36 -0.21)" />
            </svg>
          </div>
          <div id={`${itemId}-description`} className="site-item__description">
            {newsletter.description}
          </div>
        </button>
      </div>
    </div>
  );
};

PromoteSiteNewsletterItem.propTypes = {
  newsletter: PropTypes.shape({
    description: PropTypes.string.isRequired,
    top_header: PropTypes.string.isRequired,
    delivery_days: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
  }).isRequired,
  handleNewsletterSelect: PropTypes.func.isRequired,
  handleNewsletterDeselect: PropTypes.func.isRequired,
};

export default PromoteSiteNewsletterItem;
